import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../styled/theme';
import { Container, Button, Card, Flex, ButtonLink, ButtonLinkPrimary } from '../styled/BaseComponents';

const HeaderWrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: saturate(1.1) blur(10px);
  background: linear-gradient(180deg, rgba(0, 0, 0, var(--custodiy-hdrOpacity)), transparent);
  color: ${theme.colors.text};
`;

const HeaderContent = styled(Flex)`
  padding: 12px 0;
`;

const Logo = styled(Card)`
  padding: 0.5rem 1rem;
  font-weight: 900;
  font-size: 1.3rem;
  color: ${theme.colors.text};
`;

const NavWrap = styled.nav`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: ${theme.breakpoints.md}) {
    display: none;
  }
`;

const MobileNav = styled(Button)`
  @media (min-width: ${theme.breakpoints.md}) {
    display: none;
  }
`;

const MobileSheet = styled.div`
  position: fixed;
  inset: 64px 12px 12px 12px;
  background: ${theme.colors.card};
  border: 1px solid ${theme.colors.border};
  border-radius: 16px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
`;

const MobileTopbar = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const isLoggedIn = user && user.token;

  useEffect(() => {
    const onEsc = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, []);

  return (
    <HeaderWrapper>
      <Container>
        <HeaderContent justify="space-between" align="center">
          <Link to="/">
          <Logo>PharmaCrowd</Logo>
          </Link>
          <NavWrap className="desktop-nav">
            <ButtonLink to="/">Home</ButtonLink>
            <ButtonLink to="/download">Download</ButtonLink>
            {!isLoggedIn && (
              <>
                <ButtonLink to="/sign-in">Login</ButtonLink>
                <ButtonLinkPrimary to="/sign-up">Sign Up</ButtonLinkPrimary>
              </>
            )}
          </NavWrap>
          <MobileNav onClick={() => setOpen((v) => !v)}>
            <span style={{ fontWeight: 800 }}>Menu</span>
          </MobileNav>
        </HeaderContent>
        {open && (
          <MobileSheet role="dialog" aria-modal="true">
            <MobileTopbar>
              <div style={{ fontWeight: 900, color: 'var(--custodiy-text)' }}>Navigation</div>
              <Button onClick={() => setOpen(false)}>Close</Button>
            </MobileTopbar>
            <ButtonLink to="/" onClick={() => setOpen(false)}>
              Home
            </ButtonLink>
            <ButtonLink to="/banking" onClick={() => setOpen(false)}>
              Banking IBAN
            </ButtonLink>
            <ButtonLink to="/download" onClick={() => setOpen(false)}>
              Download
            </ButtonLink>
            <ButtonLink to="/privacy" onClick={() => setOpen(false)}>
              Privacy
            </ButtonLink>
            <ButtonLink to="/about" onClick={() => setOpen(false)}>
              About
            </ButtonLink>
            {!isLoggedIn && (
              <>
                <ButtonLink to="/sign-in" onClick={() => setOpen(false)}>
                  Login
                </ButtonLink>
                <ButtonLinkPrimary to="/sign-up" onClick={() => setOpen(false)}>
                  Sign Up
                </ButtonLinkPrimary>
              </>
            )}
          </MobileSheet>
        )}
      </Container>
    </HeaderWrapper>
  );
};

export default Header;

